import request from '@/utils/request'

// 获取手机号列表
export const getMobiles = () => {
  return request.get('/api/mobiles')
}
// 修改手机号状态
export const editStatus = (obj) => {
  return request.post('/api/edit', obj)
}
